export default {
  currentTicket: null,
  inviteTeamInfo: {},
  attendees: [],
  checkinSteps: {
    country: "",
    steps: [],
    kids: { steps: [] },
  },
};
